import NewsSlider from './NewsSlider';

export default NewsSlider;